/**
 * Emulate Link Interaction
 *
 * Emulates the browser's link interaction by opening in a new tab if crtl / cmd
 * is pressed while executed.
 *
 * @param href Url to open
 * @param event Keyboard or mouse event
 */
export const emulateLinkInteraction = (
  href: string,
  event:
    | React.MouseEvent<HTMLElement | HTMLOrSVGElement>
    | React.KeyboardEvent<HTMLElement | HTMLOrSVGElement>,
): void => {
  const isCtrlOrCmdPressed = event.metaKey || event.ctrlKey;
  window.open(href, isCtrlOrCmdPressed ? '_blank' : '_self');
};
